<template>
  <AppContainer is-loading />
</template>

<script setup>
import AppContainer from '@/components/AppContainer.vue'
import { useLoginRedirect } from '@/composables/useLoginRedirect.js'
import { useAppStore } from '@/stores/AppStore.js'
import { inject, onMounted } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const appStore = useAppStore()
const axios = inject('$axios')
const { redirectToLogin } = useLoginRedirect(axios)

onMounted(async () => {
  const verificationMethodsCount = appStore.getVerificationMethodsCount()

  if (verificationMethodsCount === 0) {
    await redirectToLogin()
    return
  }

  await router.push({
    name: 'auth.verification.optional',
  })
})
</script>
